import { ModelRule } from 'src/containers/ProjectDiagram/types/data';
import { ExportToFileOptions } from 'src/utils/exportToFile';

export enum CreationType {
  NEW = 'NEW',
  REPLACE = 'REPLACE',
  APPEND = 'APPEND',
}

export type ConnectionInfo = {
  databaseId: string;
  namespaceIri: string;
  namespacePrefix: string;
  shouldAddNamespace: boolean;
};

export type ModelInfo = {
  creationType: CreationType;
  modelName: string;
  namedGraphIri: string;
};

export type CsvMappingInfo = {
  creationType: CreationType;
  fileOptions: ExportToFileOptions | null;
  namedGraphIri: string;
};

export type CsvMappingsInfo = Record<string, CsvMappingInfo>;

export type VirtualGraphMappingInfo = {
  creationType: CreationType;
  virtualGraphName: string;
};

export type VirtualGraphMappingsInfo = Record<string, VirtualGraphMappingInfo>;

export type RulesInfo = Record<string, ModelRule>;

export type SensitivePropertyGroupInfo = {
  spgName: string;
  actionType: CreationType;
  publishName: string;
  attributes: string[];
};

export type SensitivePropertyGroupsInfo = Record<
  string,
  SensitivePropertyGroupInfo
>;
